<template>
  <div>
    <v-app-bar
      color="#90A4AE"
      dark>
      <h3>
        <v-icon>mdi-file-download</v-icon>
        E. 報告書の出力
      </h3>
    </v-app-bar>
    <stepper
      v-model="step"
      session-key-prefix="report-step"
      :items="steps" />
    <report-form-step1
      v-if="step===1"
      @change="goStep" />
    <report-form-step2
      v-if="step===2"
      :id="id"
      :materials="materials"
      :previous-object="previousObject"
      :license-types="licenseTypes"
      :users="users"
      :rooms="rooms"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <report-form-step3
      v-if="step===3"
      :id="id"
      @hasChange="fetchIsChanged"
      @change="goStep" />
  </div>
</template>

<script>
import ReportFormStep1 from './FormStep1'
import ReportFormStep2 from './FormStep2'
import ReportFormStep3 from './FormStep3'
import Stepper from '../Stepper'

import LeaveConfirm from '../../mixins/LeaveConfirm'

export default {
  name: 'ReportForm',
  components: {
    Stepper,
    ReportFormStep1,
    ReportFormStep2,
    ReportFormStep3,
  },
  mixins: [LeaveConfirm],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Array,
      default: () => ([
        { id: 1, title: '詳細表の選択' },
        { id: 2, title: '報告書記載項目の入力' },
        { id: 3, title: '報告書の出力' },
      ]),
    },
  },
  data() {
    return {
      materials: [],
      previousObject: {},
      licenseTypes: [],
      users: [],
      rooms: [],
    }
  },
  watch: {
    id(newVal) {
      if (newVal) {
        this.fetchPreviousObject()
      }
    },
  },
  mounted() {
    this.fetchItem()
    if (this.id) {
      this.fetchPreviousObject()
    }
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get('/api/reports/props')
      this.materials = data.materials
      this.licenseTypes = data.license_types
      this.users = data.users
      return true
    },
    async fetchPreviousObject() {
      // 差分抽出のため、前回承認前の値(previous_object)を取得する。
      const { data } = await window.axios.get(`/api/reports/${this.id}`)
      this.rooms = data.rooms
      const { previous_object: object } = data
      if (!object || !object.id || !object.report_created_at) {
        this.previousObject = {}
        return
      }
      if (object.materials) {
        object.materials
          .filter(item => !!item.pivot.other_text)
          .forEach(item => { data.previous_object.material_other_text = item.pivot.other_text })
      }
      this.previousObject = object
    },
    goStep(step) {
      this.$router.push({ name: `reportEditStep${step}` })
    },
  },
}
</script>
